import { createActions, } from 'redux-actions';

export default createActions({
  ANALYTICS: {
    PUSH: null,
  },
});
